import React from "react";
import { SimpleSaleProps } from "./utils/types";
import { SaleTable } from "./utils/SaleTable";

export const SimpleSale: React.FC<SimpleSaleProps> = ({ data }) => {
    const saleData =
        data.appealDetails?.appealApproachCalculationData.exportAppealsPackage?.valueBasedSale
            ?.previousYear;

    return <SaleTable saleData={saleData} type="simple" />;
};
